import Color from "color";
import styled, { css } from "styled-components";
import { Link } from "../link";

const sharedStyle = css<Props>`
  color: ${(props) => {
    if (props.color) {
      return props.theme.colors[props.color];
    }
    return "white";
  }};
  display: ${(props) => (props.block ? "block" : "")};
  width: 200px;
  width: fit-content;
  position: relative;
  padding: 14px 28px;
  line-height: normal;
  text-decoration: none;
  border: 1px solid
    ${(props) =>
    props.bg ? props.theme.colors[props.bg] : props.theme.colors.froly};
  border-radius: 0;
  min-width: 200px;
  font-size: 12px;
  @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
    font-size: 14px;
  }
  text-align: center;
  user-select: none;
  font-weight: 500;
  transition: box-shadow 0.3s ease-in-out;
  margin: ${(props) => {
    if (props.center) {
      return "0 auto";
    }
    return props.margin || "0";
  }};
  background-color: transparent;
  transition: color 0.45s cubic-bezier(0.785, 0.135, 0.15, 0.86),
    border 0.45s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  cursor: pointer;
  z-index: 1;
  -webkit-tap-highlight-color: initial;
  :focus {
    outline: 2px solid
      ${(props) =>
    props.bg
      ? props.theme.colors[props.bg]
      : props.theme.colors.monteCarlo};
  }
  :active {
    outline: 2px solid
      ${(props) =>
    props.bg
      ? props.theme.colors[props.bg]
      : props.theme.colors.monteCarlo};
  }
  :before {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    transform: scale(1, 1);
    transform-origin: left center;
    z-index: -1;
    transition: transform 0.45s cubic-bezier(0.785, 0.135, 0.15, 0.86);
    background-color: ${(props) =>
    props.bg ? props.theme.colors[props.bg] : props.theme.colors.froly};
  }
  :hover {
    color: ${(props) =>
    props.bg ? props.theme.colors[props.bg] : props.theme.colors.froly};
    border-color: ${(props) =>
    props.bg ? props.theme.colors[props.bg] : props.theme.colors.froly};
    :before {
      transform-origin: right center;
      transform: scale(0, 1);
    }
  }
  :disabled {
    filter: brightness(60%);
  }
`;

const Button = styled(Link) <Props>`
  ${sharedStyle}
`;

const Submit = styled.button<Props>`
  ${sharedStyle}
`;

export { Button, Submit };

export interface Props {
  bg?: string;
  block?: boolean;
  margin?: string;
  color?: string;
  center?: boolean;
}
